var _path, _circle, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCabbage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6 23.8Q62 32 54.6 40.2Q55 51.3 44 52.8Q37.2 61.6 27.8 55.6Q17 58 13.6 47.4Q3.8 42.3 8 32Q3.8 21.7 13.6 16.6Q17 6 27.8 8.4Q37.2 2.4 44 11.2Q55 12.7 54.6 23.8Z",
    fill: "#7cb83f",
    stroke: "#3f7a2a",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 34,
    r: 17,
    fill: "#a9d24e",
    stroke: "#6a9c3a",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5f9433",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 50C31 40 32 28 33 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 44C27 41 24 39 20 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 44C36 41 39 40 43 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 37C28 34 25 32 23 31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 37C36 34 39 33 42 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 30C29 28 27 27 25 26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 30C35 28 37 27 40 27"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#e6f2a6",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 29,
    rx: 3,
    ry: 6,
    transform: "rotate(-22 23 29)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 45,
    rx: 2.5,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 31,
    rx: 2,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42,
    cy: 13,
    rx: 3,
    ry: 4,
    transform: "rotate(20 42 13)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabbage);
export default __webpack_public_path__ + "static/media/cabbage.bf6c4bd836b65d146093ee3a1dff1087.svg";
export { ForwardRef as ReactComponent };